import $ from 'jquery';
import { gsap } from "gsap";

class MobileMenuItem {
    constructor(el, i) {

        this.render(el);
    }

   
    openNavigation(e) {
        this.isOpening = true;
        //gsap.killTweensOf(this.el);
        this.openAnimation.play(0);
        
    }

    closeNavigation(e) {
        if (this.isOpening) {
            this.openAnimation.reverse();
        }
        else if(!this.isCloseing){

            this.isCloseing = true;
            // gsap.killTweensOf(this.el);
            this.closeAnimation.play(0);
        }
    
    }

    setUpOpen() {
        var tl = new gsap.timeline({ paused:true, onComplete: this.openComplete.bind(this)});
         tl.set(this.background, { opacity: 0.0 });
         tl.set(this.el, { y: 0 })
        tl.fromTo(this.el, { opacity: 0 }, { opacity: 1, duration: 0.2 });
        tl.fromTo(this.background, { opacity: 0.0 }, { opacity: 0.6, scale: 1.1, y: 0, duration: 0.2 });
        tl.fromTo(this.logo, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.2 }, '>-0.2');
        tl.fromTo(this.close, { scale: 0.9 }, { scale: 1, duration: 0.2 }, '>-0.2');
        tl.from(this.links, { duration: 0.8, opacity: 0, scale: 0.9, x: -15, rotationX: 0, transformOrigin: "50% 50% 0", ease: "power3.out", stagger: 0.1 }, ">-0.2");
        tl.from(this.social, { duration: 0.8, opacity: 0, scale: 0.9, x: -15, rotationX: 0, transformOrigin: "50% 50% 0", ease: "power3.out", stagger: 0.1 }, ">-0.4");
        tl.fromTo(this.ctaBlock, { opacity: 0}, { opacity: 1, duration: 0.2 }, '>-0.8');
        tl.fromTo(this.ctaLabel, { opacity: 0, scale: 0.9, x: -15 }, { opacity: 1, scale: 1, x: 0, duration: 0.2}, '>-0.2');

        this.openAnimation = tl;
    }

    openComplete() {
        this.isOpening = false;
    }

    closeComplete() {
        this.isCloseing = false;
        gsap.set(this.el, { clearProps: "transform" });
    }

    setUpClose() {
        var tl = new gsap.timeline({ paused: true, onComplete: this.closeComplete.bind(this) });

        var animation = { opacity: 0, scale: 0.9, x: -15, duration: 0.2 };

        tl.to(this.ctaLabel, animation);
        tl.to(this.ctaBlock,    animation, 0) 
        tl.to(this.social,      animation, 0) 
        tl.to(this.links,       animation, 0) 
        tl.to(this.background, { opacity: 0.0, scale: 1, duration: 0.2 }, ">-0.1");
        tl.to(this.logo,       { opacity: 0, scale: 0.9, duration: 0.2 }, '>-0.2');
        tl.to(this.close,      { scale: 0.9, duration: 0.2 }, '>-0.2');
        tl.to(this.el, { opacity: 0, duration: 0.2 }, '>-0.2');
        this.closeAnimation = tl;
    }


    


    render(el) {

        this.el = $(el);
  
        this.linksContainer = this.el.find('[data-ref="links"]');
        this.links = this.el.find('[data-ref="link"]');
        this.background = this.el.find('[ data-ref="background"]');
        this.logo = this.el.find('[data-ref="logo"]');
        this.close = this.el.find('[data-ref="close"]');
        this.social = this.el.find('[data-ref="social"]');
        this.ctaBlock = this.el.find('[data-ref="cta"]');
        this.ctaLabel = this.el.find('[data-ref="cta"] span')
  

        this.setUpOpen();
        this.setUpClose();

        $(document).on('open-menu', this.openNavigation.bind(this));
        this.close.on('click', this.closeNavigation.bind(this));

        window.test123 = this;
        
    }
}

class MobileMenu {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new MobileMenuItem(el, index);
    }
}

export default MobileMenu;
